<div [class.print-hidden]="isPrintEnable">
  <eds-panel theme="dark" [edsSpacing]="'none'">
    <div edsGrid>
      <!-- breadcrumbs  area -->
      <eds-breadcrumbs [items]="breadcrumbItems" theme="dark">
      </eds-breadcrumbs>
    </div>
  </eds-panel>
  <ft-tax-list-info-filters
    [taxYear]="taxYear"
    [filters]="filters"
    [recordDetails]="recordDetails"
    (filterListing)="onFilterApplied($event)"
    [downloadTypes]="downloadTypesMenu"
    (downloadEvent)="onDownloadAction($event)"
  ></ft-tax-list-info-filters>
  <div edsGrid>
    <div
      class="{{
        (isCardView$ | async) ? 'cards-mobile' : 'container container--wide'
      }}"
    >
      <!-- First row -->
      <div edsRow edsSpacing="md">
        <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '7' }">
          <eds-proximal
            edsSpacing="lg"
            [placement]="'USTaxInfoPageTop'"
          ></eds-proximal>
        </div>
      </div>
      <!-- for FP users -->
      <ng-container *ngIf="isSegmentFP">
        <div edsRow edsSpacing="md">
          <div edsCol>
            <p>
              <strong class="bold">{{
                "products.us-tax-info-currently-viewing" | translate
              }}</strong>
            </p>
            <eds-toggle
              *ngIf="isPopulated && taxInfoToggleButtons.length > 0"
              [toggleButtons]="taxInfoToggleButtons"
              [isNoWrap]="false"
              (toggleActive)="updateToggle($event.value)"
            ></eds-toggle>
          </div>
        </div>
        <!-- title for the active toggle -->
        <div *ngIf="isPopulated" edsRow edsSpacing="md">
          <div edsCol>
            <eds-title
              size="h4"
              [level]="3"
              theme="basic"
              [title]="title"
            ></eds-title>
            <p edsSpacing="none" *ngIf="subtitle" [innerHTML]="subtitle"></p>
          </div>
        </div>

        <ng-container
          *ngIf="(currentPage$ | async)?.length === 0 && isShowEmptyState"
        >
          <!-- Empty state for  not logged in users -->
          <ng-container
            *ngIf="(isLoggedIn$ | async) === false; else loggedInEmptyState"
          >
            <div edsRow>
              <div edsCol>
                <!-- Empty state for held products -->
                <ng-container
                  *ngIf="activeToggle === TaxInfoToggleValues.HELD_PRODUCTS"
                >
                  <!-- Empty state for unknown users for held products -->
                  <ng-container *ngIf="!isIdentified">
                    <!-- Sign in panel -->
                    <ft-sign-in
                      [inputParameters]="signInInputParameters"
                    ></ft-sign-in>
                  </ng-container>
                  <!-- Empty state for held products for identified users -->
                  <ng-container *ngIf="isIdentified">
                    <ng-container
                      [ngTemplateOutlet]="loggedInEmptyState"
                    ></ng-container>
                  </ng-container>
                </ng-container>
                <!-- Empty state for  favorite products -->
                <ng-container
                  *ngIf="activeToggle === TaxInfoToggleValues.FAVORITE_PRODUCTS"
                >
                  <ng-container
                    *ngIf="
                      (isIdentified &&
                        (isProfileActivated$ | async) === true) ||
                      !isIdentified
                    "
                  >
                    <!-- Sign in panel -->
                    <ft-sign-in
                      [inputParameters]="signInInputParameters"
                    ></ft-sign-in>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isIdentified && (isProfileActivated$ | async) === false
                    "
                  >
                    <!-- Activation panel -->
                    <ng-container [ngTemplateOutlet]="activateProfile">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Spinner -->
      <div *ngIf="!isPopulated" edsRow edsSpacing="md">
        <div edsCol [ngStyle]="{ position: 'relative', 'min-height': '100px' }">
          <ngx-spinner
            name="taxListInfoSpinner"
            bdColor="transparent"
            size="medium"
            color="#e8e8e8"
            type="line-scale-party"
            [fullScreen]="false"
          ></ngx-spinner>
        </div>
      </div>

      <!-- Listing section -->
      <div edsRow *ngIf="isPopulated">
        <div edsCol>
          <eds-dynamic-table
            *ngIf="
              isPopulated &&
              ((currentPage$ | async)?.length > 0 || isRecordsAvailable)
            "
            [colDefs]="colDefs"
            idCol="fundShareClassId"
            [rowTemplate]="customTaxInfoRowTemplate"
            [mobileTemplate]="customTaxInfoRowTemplate"
            [rowData]="currentPage$ | async"
            [showPagination]="true"
            tableTheme="secondary"
            padding="md"
            [pageSize]="25"
            [pageSizeOptions]="[25, 50, 75, 100]"
            [cardBreakpoint]="FrkBreakpoint.Tablet"
            [hasCheckboxColumn]="true"
            [hasStickyHeader]="true"
            [hasBorders]="true"
            [labelNoMatchingData]="
              'products.us-tax-info-page-no-filter-result-message' | translate
            "
            [labelDropdown]="'products.items-per-page' | translate"
            [labelDropdownAria]="'products.items-per-page' | translate"
            [labelToggleAllCheckboxes]="
              'products.us-tax-info-page-select-all-group-header-input-label'
                | translate
            "
            [sortAccessibilityText]="'common.sortAccessibilityText' | translate"
            [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
            [sortAriaLiveText]="'common.sortAriaLiveText' | translate"
            [pageTransitionAriaLiveText]="
              'common.pageTransitionAriaLiveText' | translate
            "
            (checkboxChanged)="onChangeSelection($event)"
          ></eds-dynamic-table>
          <!-- custom template used for generating table rows -->
          <ng-template
            let-item
            let-callback="checkboxCallback"
            #customTaxInfoRowTemplate
          >
            <ft-tax-info-row
              [taxInfoItem]="item"
              (checkboxToggled)="callback(item, $event)"
              (print)="print(printType.SINGLE, $event)"
              [expandAll]="expandAll"
            ></ft-tax-info-row>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <eds-sticky-footer
    [itemCount]="rowCountValue"
    [isHide]="rowCount === 0"
    variation="2"
    [primaryAction]="downloadStickyButton"
    [secondaryAction]="printStickyButton"
    (btnSubscribePrimary)="onDownloadAction(downloadType.SELECTED)"
    (btnSubscribeSecond)="print(printType.SELECTED)"
    [stickyFooterName]="'us_taxinfo_sticky_footer'"
  ></eds-sticky-footer>
</div>
<div *ngIf="isPrintEnable">
  <ft-tax-list-info-print
    [printableRecords]="printableRecords"
    [printWindow]="isPrintEnable"
  ></ft-tax-list-info-print>
</div>
<!-- Activation panel -->
<ng-template #activateProfile>
  <eds-panel [hasPadding]="true" theme="highlight-blue">
    <eds-title edsSpacing="sm" size="h4" theme="basic">
      {{ "products.us-tax-info-activate-your-profile" | translate }}
    </eds-title>
    <p edsSpacing="sm">
      {{ "products.us-tax-info-activate-your-profile-content" | translate }}
    </p>
    <button edsButton="primary" size="compact" (click)="goToAuth0()">
      <span class="ft__btn__txt">
        {{ "signin.fastTrackRegistrationButton" | translate }}
      </span>
    </button>
  </eds-panel>
</ng-template>
<!-- Empty state for  logged in users -->
<ng-template #loggedInEmptyState>
  <div edsRow>
    <div edsCol>
      <p
        innerHTML="{{ 'products.us-tax-info-empty-state-message' | translate }}"
      ></p>
    </div>
  </div>
</ng-template>
